import { defineMessages } from 'react-intl';

export default defineMessages({
	documentTitle: {
		defaultMessage: 'Approvals',
		description: 'title of the approval list page',
		id: 'cv.approval.list.document.title',
	},
	title: {
		defaultMessage: 'Approvals',
		description: 'headline of the approval list page',
		id: 'cv.approval.list.title',
	},
});
